module.exports = __webpack_public_path__ + "static/media/badge_corner_featured.149ec2cd.png";